import { Deal, DealStateEnum } from '../gql/dealGql';
import { DocumentProgressStatus, Deal as GeneratedDeal } from '../gql/generated/graphql';

type GetDatesInDealStateOptions = {
  deal: Pick<GeneratedDeal, 'deal_states'> | Pick<Deal, 'deal_states'>;
  state: DealStateEnum;
};

// Get array of dates in the state, sorted by most recent first
const getDatesInDealState = ({ deal, state }: GetDatesInDealStateOptions) =>
  deal.deal_states
    ? deal.deal_states
        .filter((ds) => ds?.state === state && ds?.updated_date_utc != null)
        .map((ds) => new Date(ds?.updated_date_utc))
        .sort((a, b) => b.getTime() - a.getTime())
    : [];

// If no state is provided, use the deal's current state. A deal will always be in a state.
export const mostRecentMoveToDealState = (
  deal: Pick<GeneratedDeal, 'state' | 'deal_states'> | Pick<Deal, 'state' | 'deal_states'>,
  state?: DealStateEnum,
) => getDatesInDealState({ deal, state: (state ?? deal.state) as DealStateEnum })[0] ?? null;

const dealStateValues = new Set<string>(Object.values(DealStateEnum));
const isDealStateEnum = (value?: string | null): value is DealStateEnum =>
  value != null && dealStateValues.has(value);
export const dealStateFromString = (value?: string | null): DealStateEnum | null =>
  isDealStateEnum(value) ? value : null;

const adobeDocumentProgressStatusValues = new Set<string>(Object.values(DocumentProgressStatus));
const isDocumentProgressStatusEnum = (value?: string | null): value is DocumentProgressStatus =>
  value != null && adobeDocumentProgressStatusValues.has(value);
export const adobeDocumentProgressStatusFromString = (
  value?: string | null,
): DocumentProgressStatus | null => (isDocumentProgressStatusEnum(value) ? value : null);
